if (!customElements.get('fake-variants')) {
  customElements.define('fake-variants',
    class FakeVariants extends HTMLElement {
      constructor() {
        super();
    
        this.elements = {
          container: this,
          clickableElements: this.querySelectorAll('[data-fake-variant-url]')
        };
    
        this.setupEventListeners();
      } 
    
      // Creates the event listeners
      setupEventListeners() {
        this.elements.clickableElements.forEach(element => {
          element.addEventListener('click', this.handleClick.bind(this));
        });
      }

      // Handles the click event
      handleClick(event) {
        event.preventDefault();
        
        const defaultLocale = document.documentElement.dataset.defaultLocale;
        const currentLocale = document.documentElement.getAttribute('lang');
        let url = event.currentTarget.dataset.fakeVariantUrl;

        if (currentLocale !== defaultLocale) {
          url = `/${currentLocale}${url}`;
        }

        window.location.href = url;
      }
    }
  );
}